import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.FETCH_SAME_DAY_BAGS.REQUEST, saga.fetchSameDayBags);
}
